$(function(){

    //------------------------------------------------------------
    // 現在のページの情報取得
    //------------------------------------------------------------

    //パス取得（ディレクトリのみ）
    var loc = window.location.pathname;
    //配列にする(空は削除) 
    var arr = loc.split('/').filter(function(x){return x !== '';});
    //カレントディレクトリを取得
    var dir = arr[arr.length -1];
    //カレントディレクトリ名（日本語）を取得
    var catName = $("#" + dir).text();

    //------------------------------------------------------------
    // パンくず
    //------------------------------------------------------------

    //配列を回してパンくず出力
    var path = "/";
    if(arr.length > 1){
      for (var i=0; i<arr.length -1; i++) {
        //ディレクトリ
        path +=  arr[i] + "/";
        //ディレクトリ名（日本語）
        name = $("#" + arr[i]).text();
        //リンクを生成
        $(".breadlist").append("<li><a href='" + path + "'>" + name + "</a>");;
      }
    }
    //カレントを追加
    $(".breadlist").append("<li class='current'>" + catName + "</li>");

    //------------------------------------------------------------
    // リンクボタン生成
    //------------------------------------------------------------

    //h1設定
    $("h1").text(catName);
    //サイドナビからリンクリストをクローン
    $("#" + dir).next(".child-box").clone().removeClass().appendTo('#canvas');
    //非表示を解除
    $("#canvas ul").css('display','');
    //クラスを削除
    $("#canvas a").removeClass();
    //無駄なタグを削除
    $("#canvas ul li ul").remove();
    //gridにする
    $("#canvas ul").addClass("grid");
    $("#canvas ul li").addClass("sm-12 md-4 col");
    //ボタンにする
    $("#canvas ul li a").addClass("button expanded");
    $("#canvas ul li a").wrapInner('<span/>');
    //アイコン種類の設定
    $("#canvas ul li a span").addClass('longarrow');

  });